import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Card,
  Grid,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";

const CompanySelectionModal = ({
  open,
  onClose,
  experiences,
  companies,
  onSelectCompany,
}) => {
  const rawList = companies || experiences || [];
  const currentExperiences = rawList.filter((item) => {
    // If it's a formatted company from filterUtil, keep it
    if (item.id || item.cid || item.companyName) return true;
    return item.is_currently_working && item.is_verified;
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          bgcolor: "#f8f9fa",
          color: "#0044C6",
          fontWeight: "bold",
        }}
      >
        Select Company that you want to post a job for
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {currentExperiences?.map((experience, index) => {
            const companyName = experience.companyName || experience.company_name;
            const companyLogo = experience.companyLogo || experience.company_logo;
            const cardKey = experience.id || experience.entityId || index;

            return (
              <Grid item xs={12} key={cardKey}>
                <Card
                  sx={{
                    p: 2,
                    cursor: "pointer",
                    "&:hover": {
                      bgcolor: "#f5f5f5",
                      border: "1px solid #0044C6",
                      transform: "translateY(-2px)",
                      transition: "all 0.2s",
                    },
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 2,
                  }}
                  onClick={() => onSelectCompany(experience)}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    {companyLogo ? (
                      <img
                        src={companyLogo}
                        alt={companyName}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <BusinessIcon
                        sx={{
                          fontSize: 30,
                          color: "#9e9e9e",
                        }}
                      />
                    )}
                  </Box>
                  <Box
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography variant="h6" sx={{ color: "#0044C6" }}>
                      {companyName}
                    </Typography>
                    {experience.is_verified !== false ? (
                      <VerifiedTick className="green-verified-tick" />
                    ) : (
                      <VerifiedTick />
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      color: "#666",
                    }}
                  >
                    <LocationOnIcon sx={{ fontSize: 16 }} />
                    <Typography variant="body2">
                      {experience.location || "Remote"}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            color: "gray",
            fontWeight: "bold",
          }}
        >
          * Only verified working professionals can post a job.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanySelectionModal;

